module.exports = __webpack_public_path__ + "static/media/wood-0.b02552c9.gif";